import React from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { AppPrimaryButton } from 'elements'
import { useSubscriptionUsage } from 'context/subscription-usage'
import {
    ACCOUNT_CHECKOUT_PATH,
    ENABLE_FREE_PLAN_USAGE_UI,
    ENABLE_LICENSE_SHOPPING_CART,
    getWorstTone,
    isFreeTier,
} from 'utility/subscription-usage'

const Banner = styled.div`
    display: flex;
    gap: 12px;
    align-items: flex-start;
    padding: 12px 16px;
    border-radius: 8px;
    border: 1px solid;
    margin-bottom: 16px;
    font-size: 13px;
    line-height: 1.55;
    &.warn {
        background: #fffbeb;
        border-color: #fde68a;
        color: #92400e;
    }
    &.over {
        background: #fef2f2;
        border-color: #fecaca;
        color: #991b1b;
    }
    .icon {
        font-size: 16px;
        line-height: 1.2;
        font-weight: 700;
    }
    .body {
        flex: 1;
        min-width: 0;
    }
    .body strong {
        font-weight: 700;
        display: block;
        margin-bottom: 2px;
    }
    .actions {
        display: flex;
        align-items: center;
        flex-shrink: 0;
    }
    @media (max-width: 930px) {
        flex-direction: column;
        align-items: stretch;
        .actions {
            width: 100%;
        }
        .actions button {
            width: 100%;
        }
    }
`

export const PlanLimitBanner = ({
    className,
    onUpgrade = null,
    showUpgradeButton = true,
}) => {
    const navigate = useNavigate()
    const { freeUsage } = useSubscriptionUsage()
    if (!ENABLE_FREE_PLAN_USAGE_UI) return null
    if (!freeUsage || !isFreeTier(freeUsage.tier)) return null
    const tone = getWorstTone(freeUsage)
    if (tone !== 'warn' && tone !== 'over') return null

    const isOver = tone === 'over'
    const handleUpgrade = () => {
        if (typeof onUpgrade === 'function') {
            onUpgrade()
            return
        }
        navigate(ACCOUNT_CHECKOUT_PATH)
    }

    return (
        <Banner className={`${tone}${className ? ` ${className}` : ''}`}>
            <span className="icon">{isOver ? '●' : '⚠'}</span>
            <div className="body">
                <strong>
                    {isOver
                        ? "You've reached your Free plan limit."
                        : 'You are approaching your Free plan limit.'}
                </strong>
                {isOver
                    ? 'Upgrade to add more users or templates.'
                    : "Upgrade to add capacity before you're blocked."}
            </div>
            {showUpgradeButton && ENABLE_LICENSE_SHOPPING_CART && (
                <div className="actions">
                    <AppPrimaryButton type="button" onClick={handleUpgrade}>
                        {isOver ? 'Upgrade to keep everyone' : 'Upgrade Plan'}
                    </AppPrimaryButton>
                </div>
            )}
        </Banner>
    )
}
